class MaTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', e => this.handleKeydown(e));
    });
  }

  selectTab(tab) {
    this.tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
      t.classList.remove('is-active');
    });

    this.panels.forEach(p => p.classList.add('is-hidden'));

    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tab.classList.add('is-active');

    const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
    if (panel) panel.classList.remove('is-hidden');
  }

  handleKeydown(e) {
    const tabs = this.tabs;
    const index = tabs.indexOf(e.target);

    let next;
    if (e.key === 'ArrowRight') {
      next = tabs[(index + 1) % tabs.length];
    } else if (e.key === 'ArrowLeft') {
      next = tabs[(index - 1 + tabs.length) % tabs.length];
    } else if (e.key === 'Home') {
      next = tabs[0];
    } else if (e.key === 'End') {
      next = tabs[tabs.length - 1];
    }

    if (next) {
      e.preventDefault();
      this.selectTab(next);
      next.focus();
    }
  }
}

customElements.define('ma-tabs', MaTabs);
